import React from"react";

const contests = [
 {
 title:"Weekly Coding Challenge",
 description:"Solve 5 timed problems every week. Top scorers win badges.",
 type:"Weekly",
 },
 {
 title:"Monthly SkillGen Contest",
 description:
"Compete across tech tracks. Winners get certificates and rewards.",
 type:"Monthly",
 },
 {
 title:"Monthly Hackathon League",
 description:
"Team up or go solo. Win SkillGen coins and internship opportunities.",
 type:"Hackathon",
 },
];

const getTagColor = (type) => {
 switch (type) {
 case"Weekly":
 return"var(--primary-blue, #4F46E5)";
 case"Monthly":
 return"#7C3AED";
 case"Hackathon":
 return"#22D3EE";
 default:
 return"#64748B";
 }
};

const ContestPage = () => {
 return (
 <div className="min-h-screen bg-bgMain text-body flex items-center justify-center px-6 py-20 relative overflow-hidden font-sans">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 <div className="w-full max-w-6xl bg-bgSection rounded-[32px] p-10 md:p-16 border border-primary/30 shadow-2xl relative z-10 overflow-hidden"
 style={{ boxShadow:"0 0 40px rgba(37, 99, 235, 0.15)" }}>
 
 {/* Background glow */}
 <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>

 <h2 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent text-center mb-16 uppercase tracking-tighter">
 SkillGenPro <span className="text-white">Contests</span>
 </h2>

 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
 {contests.map((contest, idx) => (
 <div key={idx} className="bg-bgMain border border-accentGray/30 rounded-3xl p-8 flex flex-col items-start transition-all duration-300 hover:scale-[1.05] hover:border-primary hover:shadow-2xl group">
 <span 
 className="px-4 py-1 rounded-full text-white font-bold text-xs uppercase tracking-widest mb-6 shadow-lg"
 style={{ backgroundColor: getTagColor(contest.type) }}
 >
 {contest.type}
 </span>
 
 <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-primary transition-colors leading-tight">
 {contest.title}
 </h3>
 
 <p className="text-muted text-sm leading-relaxed mb-8 flex-grow">
 {contest.description}
 </p>
 
 <button className="w-full btn-primary-gradient py-4 rounded-2xl font-bold shadow-xl transition-all active:scale-95">
 Participate Now
 </button>
 </div>
 ))}
 </div>

 <div className="mt-20 text-center border-t border-accentGray/50 pt-12">
 <p className="text-muted font-medium mb-4 italic">
"Coding is not just about solving problems, it's about winning the challenge."
 </p>
 <div className="flex justify-center gap-2">
 <div className="w-2 h-2 rounded-full bg-primary"></div>
 <div className="w-2 h-2 rounded-full bg-secondary"></div>
 <div className="w-2 h-2 rounded-full bg-primary"></div>
 </div>
 </div>
 </div>
 </div>
 );
};

export default ContestPage;




